import React from "react";
import { useHistory } from "react-router-dom";
import { FormControl, Grid, IconButton } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { useStyles } from "./classes";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";

import SearchInput from "./SearchInputHeader";
import SearchItems from "./SearchItemsHeader";

const HeaderSearch = (props) => {
  // const [initialValues, setInitialValues] = useState({
  //   // eslint-disable-line
  //   id: "",
  //   type: "",
  //   coordinates: { lat: "", lng: "" },
  //   name: "",
  //   location: "",
  // });
  const initialValues = useSelector((state) => state.showSearch.initialValues);
  // console.log("initialValues", initialValues);

  const classes = useStyles();

  let history = useHistory();

  //update
  const onSearch = (e) => {
    if (e.type === "restaurant") {
      localStorage.setItem("searchSuccess", JSON.stringify({ e }));
      history.push(`/restaurant/${e.id}/search`);
      // history.push("/restaurant", { id: e.id });
    } else {
      localStorage.setItem("searchSuccess", JSON.stringify({ e }));
      history.push("/search", e);
    }
  };

  // validation schema
  let validationSchema = Yup.object().shape({
    // coordinates: Yup.object().shape({
    //   lat: Yup.number().required(),
    //   lng: Yup.number().required(),
    // }),
    id: Yup.string().required(""),
    type: Yup.string().required(""),
  });

  const validateInput = (values) => {
    if (values.type === "restaurant") {
      if (values.id) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        values.coordinates &&
        values.coordinates.lat &&
        values.coordinates.lng &&
        values.id &&
        values.type
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  return (
    <>
      <div className={classes.rootDisplay}>
        <Grid item lg={12}>
          <Formik
            initialValues={initialValues}
            onSubmit={onSearch}
            validationSchema={validationSchema}
            enableReinitialize
          >
            {({ dirty, isValid, values, setFieldValue }) => {
              return (
                <Form>
                  <Grid container alignItems="center">
                    <Grid
                      item
                      sm={6}
                      md={5}
                      lg={5}
                      className={classes.gapSpaceHeader}
                    >
                      <FormControl fullWidth>
                        <SearchInput
                          setFieldValue={setFieldValue}
                          values={values}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item sm={5} md={6} lg={6}>
                      <FormControl fullWidth>
                        <SearchItems setFieldValue={setFieldValue} />
                      </FormControl>
                    </Grid>
                    <Grid item className={classes.gapSpaceHeader}>
                      <IconButton
                        className={classes.buttonTwo}
                        type="submit"
                        disabled={validateInput(values)}
                      >
                        <SearchIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </Grid>
      </div>
    </>
  );
};

export default HeaderSearch;
